import store from '../store/index';
import PaymentProcessor from './paymentProcessor';
import constant from '../constants';
import {
  getIncentivePlanDetails,
  toggleIncentive,
  selectIncentive,
  getGatewayIncentiveDetails,
  toggleGatewayIncentive,
  selectGatewayIncentive,
  showErrorMessagePopup,
  handlePromise,
  toggleLoader,
  showInputError,
  removeInputError,
  removeTeamsMessage,
  showTeamsMessage,
  sendGaCheckoutFailureEvent,
  sendGaCheckoutSuccessEvent,
} from '../lib';
import { PLG_CHECKOUT_TEMPLATES } from '../constants/common';

let state = store.state.cartState ? store.state.cartState : {};

export async function processCheckout() {
  const {selected_gateway: selectedGateway} = state;

  let isValid = fieldsValidation();
  fieldsToFocus();
  if (!isValid) return;

  try {
    toggleLoader(true);
    let paymentProcessor = new PaymentProcessor(selectedGateway);
    const [processRes, processErr] = await handlePromise(paymentProcessor.process());

    if (processErr) throw processErr;
    sendGaCheckoutSuccessEvent();
  } catch (err) {
    toggleLoader(false);
    sendGaCheckoutFailureEvent(err.message);
    console.log(err);
    showErrorMessagePopup({errorMessage: err.message || ''});
  }
}

export function fieldsValidation(ele = null) {
  let isValid = true;
  let fieldsToBeValidate = {input_email: ['!empty', 'email'], input_password: ['!empty', 'password']};

  if (state.selected_gateway === 'stripe') {
    fieldsToBeValidate['input_name'] = ['!empty'];
    fieldsToBeValidate['card-element'] = ['card'];
  }

  if (ele) {
    let elementId = ele.getAttribute('id');
    if (fieldsToBeValidate[elementId]) fieldsToBeValidate = {[elementId]: fieldsToBeValidate[elementId]};
    if (ele.value !== '') removeInputError(ele);
  }

  for (const field in fieldsToBeValidate) {
    let inputElement = document.querySelector(`#${field}`);
    if (inputElement) {
      removeInputError(inputElement);
      if(inputElement?.id === 'input_email'){
      removeTeamsMessage();
      }
      let value = inputElement.value;
      let validationTypes = fieldsToBeValidate[field];
      for (const type of validationTypes) {
        switch (type) {
          case '!empty':
            if (value === '') {
              showInputError(inputElement);
              isValid = false;
            }
            break;
          case 'email':
            if (!validateEmail(value)) {
              showInputError(inputElement);
              isValid = false;
            }
            else if (isBussinessEmail(value)) {
              showTeamsMessage();
            }
            break;
          case 'password':
            if (!validatePassword(value)) {
              showInputError(inputElement);
              isValid = false;
            }
            break;
          case 'card':
            if (!validateCard()) {
              const {errors} = state;
              showInputError(inputElement, errors.invalid_card);
              isValid = false;
            }
            break;
        }
      }
    }
  }

  return isValid;
}

export function fieldsToFocus() {
  let fieldsToBeValidate = {input_email: ['!empty', 'email'], input_password: ['!empty', 'password']};
  for (const field in fieldsToBeValidate) {
    let inputElement = document.querySelector(`#${field}`);
    if (inputElement.classList.contains('error')) {
      inputElement.focus();
      return;
    }
  }
}

function validateEmail(email) {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function isBussinessEmail(email) {
  const domain = email.split("@")[1];
  return domain && window.publicDomainList?.length && !window.publicDomainList.includes(domain) ? true : false;
}

function validatePassword(password) {
  return password.length >= 8;
}

function validateCard() {
  const [element] = recurlyElements.elements;
  return element.state.valid;
}

/* Checkout button click event */
document.querySelectorAll('#submit.payment-btn, .submit.payment-btn, #gpay-sec').forEach(checkoutButon => {
  checkoutButon?.addEventListener('click', function (e) {
    e.preventDefault();
    let {
      pre_selected_addon: preSelectedAddon,
      addon_country: addonCountry,
      addon_country3: addonCountry3,
      addon_city: addonCity,
      selected_plan: selectedPlan
    } = state;

    preSelectedAddon = selectedPlan.addons
        .map(addon => preSelectedAddon.includes(addon.code) && addon.optional == '0' ? addon.code : null)
        .filter(code => code != null);

    /* checking if country or city is selected for pre-selected addon case */
    if (preSelectedAddon &&
      ((constant.addonWithCountries.some(addon => preSelectedAddon.includes(addon)) && !addonCountry && !addonCountry3) ||
        (constant.addonWithCities.some(addon => preSelectedAddon.includes(addon)) && !addonCity))) {
      showErrorMessagePopup({
        errorMessage: 'Please select country.',
        cb: () => {
          //TODO: Remove jquery code
          $('html, body').animate(
            {
              scrollTop: $('.cart-box.active').offset().top,
            },
            500,
          );
        },
      });
      return;
    }

    /* checking if fields has error */
    let isValid = fieldsValidation();
    fieldsToFocus();
    if (!isValid) return;

    const isPLGCheckoutTemplate = PLG_CHECKOUT_TEMPLATES.includes(state?.template_name);
    // Except PLG Temaples
    if(!isPLGCheckoutTemplate){
      /* If incentive applicable */
      const incentivePlanDetails = getIncentivePlanDetails();
      if (incentivePlanDetails) {
        toggleIncentive(true);
        return;
      }
    }

    /* If Gateway incentive applicable */
    const gatewayIncentivePlanDetails = getGatewayIncentiveDetails();
    if (gatewayIncentivePlanDetails && gatewayIncentivePlanDetails.discounted_amount && gatewayIncentivePlanDetails.billed_amount) {
      toggleGatewayIncentive(true);
      return;
    }

    /* If gpay is selected */
    if (state.selected_gateway === 'gpay') {
      document.querySelector('.gpay-card-info-container').click();
    }
    /* If another method is selected */
    else {
      processCheckout();
    }
  });
});

/* Incentive and gateway incentive events */
document.addEventListener('click', function (e) {
  let target = e.target;

  if (target.matches('.get_hidden_product, .get_hidden_product *')) {
    e.preventDefault();
    e.stopPropagation();
    selectIncentive();
  }

  if (target.matches('#gateway-incentive-wrapper .btn-left, #gateway-incentive-wrapper .btn-left *')) {
    e.preventDefault();
    e.stopPropagation();
    selectGatewayIncentive();
  }

  if (
    target.matches('.continue_with_product, .continue_with_product *, #gateway-incentive-wrapper .btn-right, #gateway-incentive-wrapper .btn-right *')
  ) {
    e.preventDefault();
    e.stopPropagation();
    /* If gpay is selected */
    if (state.selected_gateway === 'gpay') {
      document.querySelector('.gpay-card-info-container').click();
    }
    /* If another method is selected */
    else {
      processCheckout();
    }
  }
});
